export const CREATE_REPORT = "CREATE_REPORT";
export const FETCH_REPORTS = "FETCH_REPORTS";
export const FETCH_REPORT = "FETCH_REPORT";
export const EDIT_REPORT = "EDIT_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";
